var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioWaveDualColorIcon = function SvgAudioWaveDualColorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 97,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M38.531 96.969h-2.937V.03h2.937zM20.906 22.063H17.97v52.875h2.937zM3.281 35.28H.344V61.72H3.28zm52.875 0H53.22V61.72h2.937z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009FDB",
    fillRule: "evenodd",
    d: "M91.406 96.969H88.47V.03h2.937zM73.781 22.063h-2.937v52.875h2.937zm35.25 0h-2.937v52.875h2.937zm17.625 13.218h-2.937V61.72h2.937z",
    clipRule: "evenodd"
  })));
};
export default SvgAudioWaveDualColorIcon;